import { Container, ContainerItem } from '../common/container/Container'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'
import { EmbryoProps } from 'modules/embryos/container'
import { EMBRYO_MODULE, EMBRYO_SERVICE_KEY, EMBRYO_API_KEY } from 'modules/embryos/container'
import { EmbryoService } from 'modules/embryos/services/EmbryoService'
import { EmbryoApi } from 'modules/embryos/api/EmbryoApi'

let container: Container

function init(p: EmbryoProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(EMBRYO_API_KEY, new ContainerItem({ instance: new EmbryoApi() }))
  items.set(
    EMBRYO_SERVICE_KEY,
    new ContainerItem({
      instance: new EmbryoService({ apiKey: EMBRYO_API_KEY }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getEmbryoContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[EMBRYO_MODULE],
      },
    })
  }

  return container
}
